import type { ComponentType } from 'react'

import { OrderList, OrderDetail } from '../pages/orders'
import { ReturnList, ReturnDetail } from '../pages/returns'
import { CancellationList, CancellationDetail } from '../pages/cancellations'
import { ProductList, ProductCreate, ProductEdit } from '../pages/products'
import { SettlementAccount, SettlementDetail, SettlementHistory } from '../pages/settlements'

export interface RouteConfig {
  path: string
  List: ComponentType
  Detail?: ComponentType
  Create?: ComponentType
  Edit?: ComponentType
}

export const authenticatedRoutes: RouteConfig[] = [
  { path: '/orders', List: OrderList, Detail: OrderDetail },
  { path: '/returns', List: ReturnList, Detail: ReturnDetail },
  { path: '/cancellations', List: CancellationList, Detail: CancellationDetail },
  { path: '/products', List: ProductList, Create: ProductCreate, Edit: ProductEdit },
  { path: '/settlements/account', List: SettlementAccount },
  { path: '/settlements/history', List: SettlementHistory, Detail: SettlementDetail },
]
